import comp from "./DeleteConversation";
export default comp;
